import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ClockIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';
const navItems = [{
  to: '/',
  label: copy.nav.home
}, {
  to: '/services',
  label: copy.nav.services
}, {
  to: '/about',
  label: copy.nav.about
}, {
  to: '/gallery',
  label: copy.nav.gallery
}, {
  to: '/reviews',
  label: copy.nav.reviews
}, {
  to: '/faq',
  label: copy.nav.faq
}, {
  to: '/contact',
  label: copy.nav.contact
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const {
    t
  } = useLanguage();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 w-full" data-id="element-203" data-mp="3fbgmbknc7cxd">
      <div className="hidden bg-navy-950 text-navy-200 md:block" data-id="element-204" data-mp="3fc9ixssl0m1s">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-2 text-sm" data-id="element-205" data-mp="2wl4eqo7g82f5">
          <p className="flex items-center gap-2" data-id="element-206" data-mp="2rlhz6845ea36">
            <ClockIcon width={15} height={15} aria-hidden="true" data-id="element-207" data-mp="2ro492eeih1ok" />
            {t(business.hoursSummary)} · {business.address},{' '}
            {business.cityState}
          </p>
          <div className="flex items-center gap-4" data-id="element-208" data-mp="2hpep8g32175o">
            <span className="font-medium text-gold-300" data-id="element-209" data-mp="3fbvj1bckx2mo">
              {t(copy.topbar.spanish)}
            </span>
            <LanguageSwitcher data-id="element-210" data-mp="3adajzf92cozt" />
          </div>
        </div>
      </div>

      <div className="border-b border-navy-100 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/85" data-id="element-211" data-mp="35l9d68unzqh6">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-3" data-id="element-212" data-mp="30n7tblpezn4n">
          <Link to="/" className="flex shrink-0 items-center gap-3" aria-label={`${business.name} — ${t(copy.nav.home)}`} data-id="element-213" data-mp="1w5zazhdk3r4">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="h-12 w-12 rounded-full object-cover sm:h-14 sm:w-14" data-id="element-214" data-mp="3t90md3kwrne8" />
            <span className="hidden font-display text-lg font-bold leading-tight text-navy-900 sm:block" data-id="element-215" data-mp="1wbuxqod24cjj">
              A&amp;J Auto Repair
              <span className="block text-xs font-medium uppercase tracking-[0.18em] text-navy-500" data-id="element-216" data-mp="1mml7zf5or5yl">
                Havre de Grace, MD
              </span>
            </span>
          </Link>

          <nav className="ml-auto hidden items-center gap-1 lg:flex" aria-label={t(copy.nav.mainNav)} data-id="element-217" data-mp="1cootqehgbuw9">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `whitespace-nowrap rounded-md px-3 py-2 text-sm font-semibold transition-colors duration-150 ease-smooth ${isActive ? 'bg-navy-50 text-navy-900' : 'text-navy-600 hover:text-navy-900'}`} data-id="element-218" data-mp="yr08h5jh2lqo">
                {t(item.label)}
              </NavLink>)}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:ml-4" data-id="element-219" data-mp="w4zmbraz1h9q">
            <span className="md:hidden" data-id="element-220" data-mp="w6aqhs8bwr1d">
              <LanguageSwitcher tone="light" compact data-id="element-221" data-mp="rdhi8udnj0kj" />
            </span>
            <a href={business.phoneHref} className="hidden items-center gap-2 rounded-md border border-navy-200 px-4 py-2.5 text-sm font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:border-navy-400 hover:bg-navy-50 sm:inline-flex" data-id="element-222" data-mp="154w3z8yy1fva">
              <PhoneIcon width={16} height={16} aria-hidden="true" data-id="element-223" data-mp="1a48z0gzyxt8y" />
              {business.phoneDisplay}
            </a>
            <Link to="/contact" className="hidden rounded-md bg-gold-500 px-5 py-2.5 text-sm font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400 sm:inline-block" data-id="element-224" data-mp="3gtx38mulut8z">
              {t(copy.cta.book)}
            </Link>
            <button type="button" onClick={() => setOpen(value => !value)} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-navy-200 text-navy-900 lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? t(copy.nav.closeMenu) : t(copy.nav.openMenu)} data-id="element-225" data-mp="27x8opuc5bv6y">
              {open ? <XIcon width={22} height={22} aria-hidden="true" data-id="element-226" data-mp="1p823o0nvqrhz" /> : <MenuIcon width={22} height={22} aria-hidden="true" data-id="element-227" data-mp="1t7sziis9jxtd" />}
            </button>
          </div>
        </div>

        {open && <nav id="mobile-nav" className="border-t border-navy-100 bg-white px-6 py-4 lg:hidden" aria-label={t(copy.nav.mobileNav)} data-id="element-228" data-mp="11ho840636ain">
            <ul className="flex flex-col" data-id="element-229" data-mp="15h6smutzwjky">
              {navItems.map(item => <li key={item.to} data-id="element-230" data-mp="xyz6s5joyzui">
                  <NavLink to={item.to} className={({
              isActive
            }) => `block border-b border-navy-50 py-3.5 text-base font-semibold ${isActive ? 'text-gold-600' : 'text-navy-800'}`} data-id="element-231" data-mp="t0nuzp9u6f9n">
                    {t(item.label)}
                  </NavLink>
                </li>)}
            </ul>
            <div className="mt-4 grid gap-2" data-id="element-232" data-mp="a9eciqi38g5x">
              <a href={business.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md bg-navy-900 px-4 font-bold text-white" data-id="element-233" data-mp="5b31wdjyy1mn">
                <PhoneIcon width={18} height={18} aria-hidden="true" data-id="element-234" data-mp="3sfj7hltqbj84" />
                {t(copy.cta.call)} {business.phoneDisplay}
              </a>
              <Link to="/contact" className="flex min-h-[48px] items-center justify-center rounded-md bg-gold-500 px-4 font-bold text-navy-950" data-id="element-235" data-mp="3ni0yxwjmj60n">
                {t(copy.cta.book)}
              </Link>
            </div>
          </nav>}
      </div>
    </header>;
}